export default __webpack_public_path__ + "static/media/background-invitation.04a002ac.jpg";